import { Divider, Grid, Typography } from "@mui/material";
import { UseFormReturn, useWatch } from "react-hook-form";
import { ControlledTextField, AsyncSelect } from "src/components/forms";
import { loadSiNoOptions } from "../hooks/useOpcionesGenericas";
import { OperacionADCMFields } from "../types/fields";
import CardActions from '../../../components/CardActions';
import { SectionBox } from '../../../components/FieldView';

export const SeccionNuevoADCMBridgeLoan = ({ formMethods }: { formMethods: UseFormReturn<any> }) => {
  const { control } = formMethods;

  const isBridgeActive = useWatch({ control, name: OperacionADCMFields.Bridgeloan });
  const hasGarantias = useWatch({ control, name: OperacionADCMFields.BridgeLoanGarantias });
  const isPrecancelable = useWatch({ control, name: OperacionADCMFields.BridgeLoanPrecancelable });

  if (isBridgeActive !== 1) return null;

  return (
    <CardActions title='Detalle de Bridge Loan' icon='mdi:bridge' colapsable>
      <Grid container spacing={2.5}>

        {/* Condiciones financieras */}
        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12}>
              <ControlledTextField label='Monto' name={OperacionADCMFields.BridgeLoanMonto} control={control} currency fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Moneda' name={OperacionADCMFields.BridgeLoanMoneda} control={control} fullWidth />
            </Grid>

            <Grid item xs={12}>
              <ControlledTextField label='Comisión estructuración' name={OperacionADCMFields.BridgeLoanComisionEstructuracion} control={control} fullWidth />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField label='Tasa de interés' name={OperacionADCMFields.BridgeLoanTasaInteres} control={control} fullWidth />
            </Grid>
            <Grid item xs={12} >
              <ControlledTextField label='Plazo' name={OperacionADCMFields.BridgeLoanPlazo} control={control} fullWidth />
            </Grid>
            <Grid item xs={12} >
              <ControlledTextField label='Tipo de amortización capital' name={OperacionADCMFields.BridgeLoanTipoAmortizacionCapital} control={control} fullWidth />
            </Grid>
            <Grid item xs={12} >
              <ControlledTextField label='Frecuencia pago interés' name={OperacionADCMFields.BridgeLoanFrecuenciaPagoInteres} control={control} fullWidth />
            </Grid>
          </SectionBox>
        </Grid>

        {/* Garantías */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Garantías
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12}>
              <AsyncSelect
                label='Garantías'
                name={OperacionADCMFields.BridgeLoanGarantias}
                loadOptions={loadSiNoOptions}
                control={control}
                fullWidth
                selectNotNulleable
              />
            </Grid>
            {hasGarantias === 1 && (
              <>
                <Grid item xs={12} >
                  <ControlledTextField label='Detalle garantías' name={OperacionADCMFields.BridgeLoanDetalleGarantias} control={control} fullWidth />
                </Grid>
                <Grid item xs={12} >
                  <ControlledTextField label='Detalle aforo' name={OperacionADCMFields.BridgeLoanDetalleAforo} control={control} fullWidth />
                </Grid>
              </>
            )}
          </SectionBox>
        </Grid>

        {/* Precancelación */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Precancelación
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12}>
          <SectionBox>
            <Grid item xs={12}>
              <AsyncSelect
                label='Precancelable'
                name={OperacionADCMFields.BridgeLoanPrecancelable}
                loadOptions={loadSiNoOptions}
                control={control}
                fullWidth
              />
            </Grid>
            {isPrecancelable === 1 && (
              <Grid item xs={12} >
                <ControlledTextField
                  label='Condiciones precancelación'
                  name={OperacionADCMFields.BridgeLoanCondicionesPrecancelacion}
                  control={control}
                  fullWidth
                />
              </Grid>
            )}
          </SectionBox>
        </Grid>

      </Grid>
    </CardActions>
  );
};
